import { render, staticRenderFns } from "./BlueProject.vue?vue&type=template&id=421e7cf8&lang=pug&"
import script from "./BlueProject.vue?vue&type=script&lang=js&"
export * from "./BlueProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports